import styled from 'styled-components'
import Button from 'react-bootstrap/Button';

export const BrainzContainer = styled.div`
  background: #0c0c0c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  height: calc(100vh);
  position: relative;
  z-index: 1;
`

export const BrainzBg = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  overflow: hidden;
  filter: brightness(50%);
`


export const ShopLayoutContainer = styled.div`
  max-width: 1200px;
  padding: 0px 20px;
  min-height: 80vh;
  margin-top: 30px;
  position: absolute;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

`

export const ConnectButton = styled(Button)`
  border-radius: 20px;
  background: #9df743;
  white-space: nowrap;
  padding: 10px 40px;
  color: #000;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #181818;
    color: #9df743;
  }
`

export const ClaimButton = styled(Button)`
  border-radius: 20px;
  background: #9df743;
  white-space: nowrap;
  padding: 10px 40px;
  margin-top: 0px;
  margin-bottom: 15px;
  color: #000;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #181818;
    color: #9df743;
  }
`

export const Text = styled.h2`
  margin-top: 14rem;
  color: #9df743;
  font-size: 2rem;
  text-align: center;
  max-width: 800px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #000;
`